<template>
    <div
        v-b-tooltip.hover
        :title="$t('Billable time — only counts while video is flowing')"
    >
        {{ formattedTime }}
    </div>
</template>

<script>
import { mapState } from "vuex";

// pure renderer of call/airtimeSeconds. no timer of its own — the increment
// runs once per second inside CallBilling.vue's tick, so this display is
// always in lockstep with the counter that drives charges.
export default {
    computed: {
        ...mapState("call", ["airtimeSeconds"]),
        formattedTime() {
            const minutes = Math.floor(this.airtimeSeconds / 60);
            const seconds = this.airtimeSeconds % 60;
            const pad = (n) => (n < 10 ? `0${n}` : n);
            return `${pad(minutes)}:${pad(seconds)}`;
        },
    },
};
</script>
